<template>
  <div class="wrap-breadcrumb container-lg mt-8">
    <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [],
    };
  },
  computed: {
    matchedRoutes() {
      return this.$route.matched || [];
    },
    dynamicBreadcrumb() {
      return this.$store.getters['breadcrumb/dynamicBreadcrumb'] || [];
    },
  },
  watch: {
    matchedRoutes: {
      handler() {
        this.updateBreadcrumb();
      },
      immediate: true,
    },
    dynamicBreadcrumb: {
      handler() {
        this.updateBreadcrumb();
      },
      immediate: true,
    },
  },
  methods: {
    updateBreadcrumb() {
      let matchedArr = this.$route.matched.filter((route) => route.meta.title);
      this.breadcrumb = matchedArr.map((route) => {
        return (
          this.dynamicBreadcrumb[route.meta.key] || {
            text: route.meta.title,
            to: {name: route.name},
          }
        );
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap-breadcrumb {
  padding: 0;
  @media screen and (max-width: 768px) {
    display: none;
  }
}
.breadcrumb {
  margin: 0;
  padding: 12px 80px 12px 24px;
  flex-wrap: nowrap;
  background-color: #e9ecef;
}
.breadcrumb-item {
  line-height: 32px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 270px;
  a {
    text-decoration: underline;
  }
  &.active {
    color: #6c757d;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    max-width: 100%;
  }
  .router-link-active {
    text-decoration: underline;
  }
  &:last-of-type:before {
    padding-right: 24px !important;
  }
}
</style>
